import { render, staticRenderFns } from "./PriceAnalysis.vue?vue&type=template&id=6366efd5&scoped=true&"
import script from "./PriceAnalysis.vue?vue&type=script&lang=js&"
export * from "./PriceAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./PriceAnalysis.vue?vue&type=style&index=0&id=6366efd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6366efd5",
  null
  
)

export default component.exports